function NotFound() {
    return (
        <div className="hero is-fullheight">
            <div className="hero-body has-text-centered">
                <div className="container">
                    <h1 className="title is-size-one">Not found</h1>
                </div>
            </div>
        </div>
    )
}

export default NotFound;